import { useState } from "react";
import { supabase } from "../supabaseClient";

export function useStudentQuestionNotes(session) {
  const [studentNotes, setStudentNotes] = useState([]);
  const [newStudentNote, setNewStudentNote] = useState("");
  const [loadingStudentNotes, setLoadingStudentNotes] = useState(false);

  const fetchStudentNotes = async ({ examQuestionId, examSessionId }) => {
    if (!session?.user?.id || !examQuestionId) return [];

    setLoadingStudentNotes(true);

    const { data, error } = await supabase
      .from("student_question_notes")
      .select("id, note_text, status, created_at, updated_at")
      .eq("user_id", session.user.id)
      .eq("exam_question_id", examQuestionId)
      .eq("exam_session_id", examSessionId)
      .eq("status", "active")
      .order("created_at", { ascending: false });

    if (error) {
      alert(error.message);
      setStudentNotes([]);
      setLoadingStudentNotes(false);
      return [];
    }

    setStudentNotes(data || []);
    setLoadingStudentNotes(false);

    return data || [];
  };

  const addStudentNote = async ({
    examQuestionId,
    examSessionId,
    noteText,
  }) => {
    if (!session?.user?.id) {
      alert("Please log in first.");
      return false;
    }

    if (!noteText) {
      alert("Please enter a note.");
      return false;
    }

    const { error } = await supabase.from("student_question_notes").insert({
      user_id: session.user.id,
      exam_question_id: examQuestionId,
      exam_session_id: examSessionId,
      note_text: noteText,
      status: "active",
    });

    if (error) {
      alert(error.message);
      return false;
    }

    alert("Note added.");
    return true;
  };

  const updateStudentNote = async (noteId, noteText) => {
    if (!noteId) {
      alert("Missing note id.");
      return false;
    }

    if (!noteText) {
      alert("Note cannot be empty.");
      return false;
    }

    const { error } = await supabase
      .from("student_question_notes")
      .update({
        note_text: noteText,
        updated_at: new Date().toISOString(),
      })
      .eq("id", noteId);

    if (error) {
      alert(error.message);
      return false;
    }

    alert("Note updated.");
    return true;
  };

  const deleteStudentNote = async (noteId) => {
    if (!noteId) return false;

    const confirmDelete = window.confirm("Delete this note?");

    if (!confirmDelete) return false;

    const { error } = await supabase
      .from("student_question_notes")
      .update({
        status: "deleted",
        updated_at: new Date().toISOString(),
      })
      .eq("id", noteId);

    if (error) {
      alert(error.message);
      return false;
    }

    alert("Note deleted.");
    return true;
  };

  return {
    studentNotes,
    newStudentNote,
    setNewStudentNote,
    loadingStudentNotes,
    fetchStudentNotes,
    addStudentNote,
    updateStudentNote,
    deleteStudentNote,
  };
}